import type { SVGProps } from "react";
export function Link(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m12.8654 3.1346c-.8461-.84613-2.218-.84613-3.06413 0l-.73307.73308c-.19526.19526-.51186.19526-.70713 0s-.19527-.51184 0-.70711l.73307-.73307c1.23666-1.23667 3.24176-1.23667 4.47836 0 1.2366 1.23666 1.2366 3.24168 0 4.47837l-2.6666 2.66667c-1.2367 1.23656-3.24176 1.23656-4.4784 0-.19526-.19527-.19526-.51187 0-.70714.19526-.19526.51183-.19526.7071 0 .84614.84614 2.218.84614 3.0641 0l2.6667-2.66666c.8461-.84614.8461-2.218 0-3.06414zm-4 4c-.84613-.84613-2.21799-.84613-3.06413 0l-2.66667 2.66667c-.84613.84613-.84613 2.21803 0 3.06413.84614.8461 2.218.8461 3.06414 0l.7344-.7344c.19526-.1953.5118-.1953.70706 0 .19527.1953.19527.5119 0 .7071l-.73433.7344c-1.23669 1.2366-3.24171 1.2366-4.47837 0-1.23667-1.2366-1.23667-3.2417 0-4.47836l2.66666-2.66664c1.23666-1.23666 3.24171-1.23666 4.47838 0 .19526.19526.19526.51183 0 .7071-.19527.19527-.51187.19527-.70714 0z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
